import { create } from 'zustand';

const initialState = {
  isLoadingPage: true,
  isHideMobileNavBar: false,
  isHideHelpButton: false,
};

export const useAppSystem = create((set) => ({
  ...initialState,
  onChangeAppSystem: (newState) => set((state) => ({ ...state, ...newState })),
  onResetAppSystem: () => set(() => ({ ...initialState })),
}));
